module.exports = __webpack_public_path__ + "img/Sina.395bf71e.svg";